import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { userService } from './Pages/shared/Services/userService.service';
import { LayoutService } from './_metronic/core/services/layout.service';
import { LayoutInitService } from './_metronic/core/services/layout-init.service';
import { DOCUMENT } from '@angular/common';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService, BBSFTranslateService, MasterLayoutService, StylesBundleService, UtilityService } from 'bbsf-utilities';

@Component({
  selector: 'lib-masterlayout',
  templateUrl: './masterlayout.component.html'
})

export class MasterlayoutComponent implements OnInit, AfterViewInit {
  isExpanded = false;
  language: string;
  name: string;
  isAuthenticated: boolean;
  subscription: Subscription;
  token: string;
  // Public variables
  selfLayout = 'default';
  asideSelfDisplay: true;
  asideMenuStatic: true;
  contentClasses = '';
  contentContainerClasses = '';
  toolbarDisplay = true;
  contentExtended: false;
  asideCSSClasses: string;
  asideHTMLAttributes: any = {};
  headerMobileClasses = '';
  headerMobileAttributes = {};
  footerDisplay: boolean;
  footerCSSClasses: string;
  headerCSSClasses: string;
  headerHTMLAttributes: any = {};
  animating: boolean = false;
  // offcanvases
  extrasSearchOffcanvasDisplay = false;
  extrasNotificationsOffcanvasDisplay = false;
  extrasQuickActionsOffcanvasDisplay = false;
  extrasCartOffcanvasDisplay = false;
  extrasUserOffcanvasDisplay = false;
  extrasQuickPanelDisplay = false;
  extrasScrollTopDisplay = false;
  @ViewChild('ktAside', { static: true }) ktAside: ElementRef;
  @ViewChild('ktHeaderMobile', { static: true }) ktHeaderMobile: ElementRef;
  @ViewChild('ktHeader', { static: true }) ktHeader: ElementRef;
  currentTheme:string="ltr"
 // Decorator wires up blockUI instance
 @BlockUI() blockUI: NgBlockUI;
  constructor(
    private translate: BBSFTranslateService, 
    private authService: AuthService,
    private UtilityService: UtilityService,
    private router:Router,
    private layout: LayoutService,
    private initService: LayoutInitService,
    private stylesBundleService: StylesBundleService,
    private BBSFTranslateService: BBSFTranslateService,
    private masterLayoutService :MasterLayoutService,
    @Inject(DOCUMENT) private document: Document
    ) 
    {
   
    this.loadUI()
  }
 
  ToggleAnimation() {
    this.animating = !this.animating;
    setTimeout(() => {
      this.animating = false;
    }, 300);
  }
  async ngOnInit() {
    
    let lang = await this.UtilityService.getCurrentLanguage();
    localStorage.setItem('language', lang);
    this.translate.use(lang);
    this.language = lang;
    this.BBSFTranslateService.onLangChange.subscribe( (event) => {
      debugger ;
      if(this.language!=event.lang)
      {
        this.language=event.lang;
        this.masterLayoutService.reloadComponent()
      }
    })
    this.subscription = this.authService.authNavStatus$.subscribe(status => this.isAuthenticated = status);
    this.name = this.authService.name();
    this.language = localStorage.getItem('language');
    
    this.toolbarDisplay = this.layout.getProp('toolbar.display') as boolean;
    this.contentContainerClasses =
    this.layout.getStringCSSClasses('contentContainer');
    this.asideCSSClasses = this.layout.getStringCSSClasses('aside');
    this.headerCSSClasses = this.layout.getStringCSSClasses('header');
    this.headerHTMLAttributes = this.layout.getHTMLAttributes('headerMenu');

  }

  ngAfterViewInit(): void{
    if (this.ktHeader) {
      for (const key in this.headerHTMLAttributes) {
        if (this.headerHTMLAttributes.hasOwnProperty(key)) {
          this.ktHeader.nativeElement.attributes[key] =
            this.headerHTMLAttributes[key];
        }
      }
    }
  }

  async loadUI()
  {
    let lang = await this.UtilityService.getCurrentLanguage();
    this.stylesBundleService.loadThemes(lang,"BBSF-Bundle-English.css","BBSF-Bundle-Arabic.css");
    this.initService.init();

  }

  async signout() {
    await this.authService.signout();
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }






}
